export {default as quadtree} from "./src/quadtree";



//////////////////
// WEBPACK FOOTER
// ./~/d3-quadtree/index.js
// module id = 170
// module chunks = 0